module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1534-71c3bc2bdec1dfb13b3f6453dfff74dc.png";